export default __webpack_public_path__ + "static/media/ROCL-1.076a86ce.jpg";